/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import salesDashboardActions from "../../../../Sales/Dashboard/redux/actions";
import { currencyFormat, capitalizeFirstLetter, idNamingConversion } from "../../../../../helpers/utilities";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import ReportModal from "../../ReportModal";
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import { emptyValidation } from "../../../../../helpers/validation";
import {
    Button,
    Box
} from "@mui/material";
import clsx from "clsx";
import { Space, Col, Row } from 'antd';

export const SalesLocation = (props) => {
    const { visible, onSalesLocationVisible, title, onMenuTitle } = props;
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { salesDashboardDetails } = useSelector(state => state.salesDashboardReducer);
    const [salesLocation, setSalesLocation] = useState('');
    const [salesLocationValue, setSalesLocationValue] = useState('');
    const [salesLocationVTitle, setSalesLocationVTitle] = useState('');
    const [salesLocationValueTitle, setSalesLocationValueTitle] = useState('');
    const [customerData, setCustomerData] = useState([]);
    const [reportOpen, setReportOpen] = useState(false);
    const [errorSalesLocationValue, setErrorSalesLocationValue] = useState(false);
    const [errorSalesLocation, setErrorSalesLocation] = useState(false);
    const dispatch = useDispatch();

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        if (salesDashboardDetails !== '' && salesLocationValue !== '' && salesLocationValue !== '') {
            setCustomerData(salesDashboardDetails[salesLocationValue]);
            setReportOpen(true);
            onSalesLocationVisible(false);
        }
    }, [salesDashboardDetails])

    const salesLocationFilter = (e) => {
        e.preventDefault();
        let emptySalesLocation = emptyValidation('Sales Location', salesLocation, 'dropDown');
        let emptySalesLocationValue = emptyValidation('Sales Location', salesLocationValue, 'dropDown');
        if (emptySalesLocation.isValid && emptySalesLocationValue.isValid) {
            if (salesDashboardDetails === undefined || salesDashboardDetails === '') {
                dispatch({ type: salesDashboardActions.SALES_DASHBOARD_START, url: 'salesdashboard' });
            } else {
                setCustomerData(salesDashboardDetails[salesLocationValue]);
                setReportOpen(true);
                onSalesLocationVisible(false);
            }
        } else {
            if (emptySalesLocation.errors !== '') {
                setErrorSalesLocation(emptySalesLocation.errors);
            }
            if (emptySalesLocationValue.errors !== '') {
                setErrorSalesLocationValue(emptySalesLocationValue.errors);
            }
        }
    }

    const salesLocationTitle = (value) => {
        switch (value) {
            case "areas": return 'City - Area';
            case "pins": return 'City - Pincode';
            default: return 'City - State';
        };
    }

    const salesLocationTitleValue = (value) => {
        switch (value) {
            case "city_location_30": return 'Last 30 days';
            case "city_location_120": return 'Last 120 days';
            default: return 'Last 300 Days';
        };
    }

    const handleClose = () => {
        setSalesLocation('');
        setSalesLocationValue('');
        onSalesLocationVisible(false);
        onMenuTitle('');
        setErrorSalesLocationValue(false);
        setErrorSalesLocation(false);
        setSalesLocationVTitle('');
        setSalesLocationValueTitle('');
    }

    const classes = customStyles();
    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => salesLocationFilter(e)}>
                        <div className={classes.customFormFlex}>
                            <AutoCompleteComponent
                                name={["Number of Days ", <span key="Number of Days" className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'label', 'name': 'Number of Days' }]}
                                details={[{ "id": "city_location_30", "label": "Last 30 Days" }, { "id": "city_location_120", "label": "Last 120 Days" }, { "id": "city_location_300", "label": "Last 300 Days" }]}
                                parentValue={customObject([{ "id": "city_location_30", "label": "Last 30 Days" }, { "id": "city_location_120", "label": "Last 120 Days" }, { "id": "city_location_300", "label": "Last 300 Days" }], salesLocationValue)}
                                onChange={(data) => { setSalesLocationValue(data.id); setSalesLocationValueTitle(data.id) }}
                                position={'bottom'}
                                id={idNamingConversion('Number of Days', 'salesLocation', 'DropDown')}
                                parentError={errorSalesLocationValue}
                            />
                            <AutoCompleteComponent
                                name={["Sales Location ", <span key="Sales Location" className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'label', 'name': 'Sales Location' }]}
                                details={[{ "id": "areas", "label": "Area" }, { "id": "pins", "label": "Pincode" }, { "id": "state", "label": "State" }]}
                                parentValue={customObject([{ "id": "areas", "label": "Area" }, { "id": "pins", "label": "Pincode" }, { "id": "state", "label": "State" }], salesLocation)}
                                onChange={(data) => { setSalesLocation(data.id); setSalesLocationVTitle(data.id) }}
                                position={'bottom'}
                                id={idNamingConversion('Sales Location', 'salesLocation', 'DropDown')}
                                parentError={errorSalesLocation}
                                customClasses={classes.margin20t}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn)}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn)}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle} style={{ fontFamily: '"RobotoMedium", "Roboto"' }}>{title} - {salesLocationTitleValue(salesLocationValueTitle)}</h4>
                            <p className={classes.downloadsHeading}>{salesLocationTitle(salesLocationVTitle)}</p>
                        </div>
                        {
                            salesLocation === 'state' ? <>
                                <Row className={clsx(classes.bill, classes.billReportHead, classes.billReportHeadCustom, classes.viewPrint, 'no-break')}>
                                    <Col span={6}><h6>City</h6></Col>
                                    <Col span={6}><h6>{capitalizeFirstLetter(salesLocationVTitle === 'areas' ? 'area' : salesLocationVTitle === 'pins' ? 'Pincode' : salesLocationVTitle)}</h6></Col>
                                    <Col span={6}><h6 className={classes.textAlignRight}>Balance</h6></Col>
                                    <Col span={6}><h6 className={classes.textAlignRight}>Total</h6></Col>
                                </Row>
                                {
                                    customerData?.length > 0 ? customerData.map((data, i) => (
                                        <Row className={clsx(classes.bill, 'no-break')}>
                                            <Col span={6}><p>{data?.name}</p></Col>
                                            <Col span={6}><p>{data?.state}</p></Col>
                                            <Col span={6}><p className={classes.textAlignRight}>₹ {currencyFormat(data.balance)}</p></Col>
                                            <Col span={6}><p className={classes.textAlignRight}>₹ {currencyFormat(data.total)}</p></Col>
                                        </Row>
                                    )) : <Row className={clsx(classes.bill)}><Col span={12}>No results found</Col></Row>
                                }
                            </> : <>
                                {
                                    customerData?.length > 0 ? customerData.map((data, i) => (
                                        <div>
                                            <Row className={clsx(classes.bill, classes.billReportHead, classes.viewPrint, 'no-break', { [classes.margin20t]: i === 0 })}>
                                                <Col span={24}><h6 style={{ fontFamily: '"RobotoMedium", "Roboto"', color: "#000", justifyContent: "space-between", display: "flex" }} className={clsx(classes.bold)}>
                                                    <span><span style={{ color: "#8a8a8e", fontWeight: 400 }}>City: </span>{capitalizeFirstLetter(data.name)}</span>
                                                    <span style={{ marginLeft: 40 }}><span style={{ color: "#8a8a8e", fontWeight: 400 }}>Total: </span>₹ {currencyFormat(data.total)}</span></h6>
                                                </Col>
                                            </Row>
                                            <Row className={clsx(classes.bill, classes.billReportHead, classes.billReportHeadCustom, classes.viewPrint, 'no-break')}>
                                                <Col span={8}><h6>{capitalizeFirstLetter(salesLocationVTitle === 'areas' ? 'area' : salesLocationVTitle === 'pins' ? 'Pincode' : salesLocationVTitle)}</h6></Col>
                                                <Col span={8}><h6 className={classes.textAlignRight}>Balance</h6></Col>
                                                <Col span={8}><h6 className={classes.textAlignRight}>Total</h6></Col>
                                            </Row>
                                            {
                                                data[salesLocation]?.length > 0 ? data[salesLocation].map((data, i) => (
                                                    <Row className={clsx(classes.bill, classes.billLoop, 'no-break')}>
                                                        <Col span={8}><p>{data?.name || data?.code}</p></Col>
                                                        <Col span={8}><p className={classes.textAlignRight}>₹ {currencyFormat(data.balance)}</p></Col>
                                                        <Col span={8}><p className={classes.textAlignRight}>₹ {currencyFormat(data.total)}</p></Col>
                                                    </Row>)) : <Row className={clsx(classes.bill)}><Col span={12}>No results found</Col></Row>
                                            }
                                        </div>
                                    )) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                                }
                            </>
                        }
                    </>
                }
                businessDetails={businessDetails}
                handleClose={() => { setReportOpen(false); handleClose(); }}
            />
        </>
    )
}